import { date, literal, nullish, object, optional, picklist, pipe, string, transform, union } from 'valibot'
import {
  imagesData,
  paragraph,
  relatedDocument,
  richTextData,
  selectionData,
  singleImage,
  singleLineData,
} from '~/utils/crystallize/component-schemas'
import { crystallizeDocumentSchema } from '~/utils/crystallize/document'
import { crystallizeDefaultFolderSchema } from '~/utils/crystallize/folder'
import { cookieTablePiece, ctaPiece, factBoxPiece, faqPiece, hubspotFormPiece, lawQuotePiece, personPiece, quotePiece } from '~/utils/crystallize/pieces'

export const articleSchema = crystallizeDocumentSchema(
  'article',
  object({
    template: pipe(
      selectionData,
      transform(it => it[0]),
      optional(
        object({
          key: string(),
          value: picklist(['standard', 'testimonial', 'info-page']),
        }),
      ),
    ),
    title: nullish(singleLineData),
    headerImage: singleImage,
    leadParagraph: nullish(richTextData),
    authorsChoice: safeArray(
      union([
        object({
          type: literal('author'),
          value: personPiece,
        }),
        object({
          type: literal('ibexa-location-id'),
          value: singleLineData,
        }),
      ]),
    ),
    published: nullish(date()),
    theme: nullish(selectionData),
    body: safeArray(
      union([
        object({
          type: literal('quote'),
          value: quotePiece,
        }),
        object({
          type: literal('fact-box'),
          value: factBoxPiece,
        }),
        object({
          type: literal('law-quote'),
          value: lawQuotePiece,
        }),
        object({
          type: literal('generic-cta'),
          value: ctaPiece,
        }),
        object({
          type: literal('paragraphs'),
          value: paragraph,
        }),
        object({
          type: literal('images'),
          value: imagesData,
        }),
        object({
          type: literal('product-cta'),
          value: relatedDocument,
        }),
        object({
          type: literal('hubspot-form'),
          value: hubspotFormPiece,
        }),
        object({
          type: literal('faq'),
          value: faqPiece,
        }),
        object({
          type: literal('separator'),
          value: object({}),
        }),
        object({
          type: literal('cookie-table'),
          value: cookieTablePiece,
        }),
        object({
          type: literal('person'),
          value: personPiece,
        }),
      ]),
    ),
    footnotesSimple: nullish(richTextData),
  }),
)

export const articlesSchema = crystallizeDefaultFolderSchema(articleSchema)

/**
 * Sort articles by published date
 */
export function byPublishedDate(a: CrystallizeArticle | null | undefined, b: CrystallizeArticle | null | undefined) {
  // TODO: Fallback to actual updated field if published is missing
  const aPublished = a?.components?.published
  const bPublished = b?.components?.published

  if (aPublished && bPublished) {
    return new Date(bPublished).getTime() - new Date(aPublished).getTime()
  }

  if (aPublished && !bPublished) {
    return -1
  }

  if (!aPublished && bPublished) {
    return 1
  }

  return 0
}
